import React from 'react';
import Home from 'components/pages/Home';

function App() {
  return (
    <Home />
  );
}

export default App;
